module.exports = __webpack_public_path__ + "img/checkmark-circle-grey-green.b1ea1bf3.png";